// src/routes/citiesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Cities from '../pages/cities/Cities';
import CreateCity from '../pages/cities/CreateCity';
import EditCity from '../pages/cities/EditCity';
import ProtectedRoute from '../components/global/ProtectedRoute';

const citiesRoutes = (
    <>
        {/* Cities list */}
        <Route
            path="/cities"
            element={
                <ProtectedRoute requiredPermission="cities_list">
                    <Cities />
                </ProtectedRoute>
            }
        />

        {/* Cities archive */}
        <Route
            path="/cities/archive"
            element={
                <ProtectedRoute requiredPermission="cities_archive_list">
                    <Cities />
                </ProtectedRoute>
            }
        />

        {/* Create city */}
        <Route
            path="/cities/create"
            element={
                <ProtectedRoute requiredPermission="cities_create">
                    <CreateCity />
                </ProtectedRoute>
            }
        />

        {/* Edit city */}
        <Route
            path="/cities/:id/edit"
            element={
                <ProtectedRoute requiredPermission="cities_edit">
                    <EditCity />
                </ProtectedRoute>
            }
        />
    </>
);

export default citiesRoutes;
